import { render } from "./WhyStat.vue?vue&type=template&id=20937038&scoped=true"
import script from "./WhyStat.vue?vue&type=script&lang=js"
export * from "./WhyStat.vue?vue&type=script&lang=js"

import "./WhyStat.vue?vue&type=style&index=0&id=20937038&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20937038"]])

export default __exports__